module.exports = __webpack_public_path__ + "img/video-play.ef5b6516.svg";